import { __assign, __rest } from "tslib";
import React from 'react';
import VeltPersistentCommentModeCloseButtonWireframe from './VeltPersistentCommentModeCloseButtonWireframe/VeltPersistentCommentModeCloseButtonWireframe';
import VeltPersistentCommentModeLabelWireframe from './VeltPersistentCommentModeLabelWireframe/VeltPersistentCommentModeLabelWireframe';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltPersistentCommentModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-persistent-comment-mode-wireframe", __assign({}, transformedProps), children));
};
VeltPersistentCommentModeWireframe.CloseButton = VeltPersistentCommentModeCloseButtonWireframe;
VeltPersistentCommentModeWireframe.Label = VeltPersistentCommentModeLabelWireframe;
export default VeltPersistentCommentModeWireframe;
